/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModuleOut
 */
export interface ModuleOut {
    /**
     * 
     * @type {number}
     * @memberof ModuleOut
     */
    attributeId: number;
}

export function ModuleOutFromJSON(json: any): ModuleOut {
    return ModuleOutFromJSONTyped(json, false);
}

export function ModuleOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModuleOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attributeId': json['attributeId'],
    };
}

export function ModuleOutToJSON(value?: ModuleOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attributeId': value.attributeId,
    };
}


